import * as Types from "../actions/action.types"
export const defaultState = {
    processing: false,
    errors: [] as string[],
    userName: "",
    password: "",
    isMultiSignIn: false,
    redirectUrl: "",
    loggedFullName: "",
    isSuccess: false,
    isExpiredPassword: false,
    isNeededToChangePWD: false
}
export type ReducerState = typeof defaultState;
export function reducer(state = defaultState, action: any): ReducerState {
    switch (action.type) {
        case Types.CHANGE_LOGIN_USERNAME: {
            let payload = action.payload as Types.CHANGE_LOGIN_USERNAME_PAYLOAD;
            return {
                ...state,
                errors: [],
                userName: payload
                // password: ""
            }
        }
        case Types.CHANGE_LOGIN_PASSWORD: {
            let payload = action.payload as Types.CHANGE_LOGIN_PASSWORD_PAYLOAD;
            return {
                ...state,
                errors: [],
                password: payload
            }
        }
        case Types.CHANGE_LOGIN_PROCESSING_STATUS: {
            let payload = action.payload as Types.CHANGE_LOGIN_PROCESSING_STATUS_PAYLOAD;
            return {
                ...state,
                processing: payload
            }
        }
        case Types.SET_LOGIN_RESPONSE: {
            let payload = action.payload as Types.SET_LOGIN_RESPONSE_PAYLOAD;
            return {
                ...state,
                errors: payload.errors,
                isMultiSignIn: payload.isMultipleSignIn,
                redirectUrl: payload.redirectUrl,
                loggedFullName: payload.fullname,
                isSuccess: payload.isSuccess,
                isExpiredPassword: payload.isPwdExpiredDate
            }
        }
        case Types.SET_IS_NEEDED_TO_CHANGE_PWD: {
            let payload = action.payload as Types.SET_IS_NEEDED_TO_CHANGE_PWD_PAYLOAD
            return {
                ...state,
                isNeededToChangePWD: payload
            }
        }
        default:
            return state;
    }
}